'use client';

import React from 'react';

import {Button} from '@udemy-v2/react-core-components';
import {Icon} from '@udemy-v2/icons';
import {useI18n} from '@udemy-v2/i18n';
import {useTracker, TrackImpression} from '@udemy-v2/event-tracking';
import {CardTitle, CertificationPreparationProductCard} from '@udemy-v2/react-product-card-components';

import {Heading} from '@/lib/heading-level';
import {buildCertPrepContent} from '../../data/fixtures';
import {createDiscoveryItemClickEvent, createDiscoveryImpressionEvent} from '../../data/tracking';
import styles from './cert-prep.module.scss';

export const CertPrep: React.FC = () => {
    const {gettext} = useI18n();
    const tracker = useTracker();
    const data = buildCertPrepContent(gettext);
    return (
        <section className={styles['cert-prep']} data-purpose="cert-prep">
            <div className={styles.layout}>
                <div className={styles.sidebar}>
                    <div className={styles['sidebar-content']}>
                        <Heading className={`${styles.heading} ud-heading-xxl`}>
                            {gettext('Get certified and get ahead in your career')}
                        </Heading>
                        <p className={`${styles.subtitle} ud-text-md`}>
                            {gettext(
                                'Prep for certifications with comprehensive courses, practice tests, and special offers on exam vouchers.',
                            )}
                        </p>
                    </div>
                    <Button
                        componentClass="a"
                        href={data.exploreCTA.url}
                        udStyle="ghost"
                        size="large"
                        className="ud-link-knockout"
                    >
                        {data.exploreCTA.text}
                        <Icon glyph="next" label={false} />
                    </Button>
                </div>

                <div className={styles.cards}>
                    {data.cards.map((card, index) => (
                        <TrackImpression
                            key={card.id}
                            trackFunc={() =>
                                tracker.publishEvent(
                                    createDiscoveryImpressionEvent({
                                        id: index,
                                        type: 'course_topic',
                                        trackingId: card.id,
                                        serveTrackingId: '',
                                        backendSource: 'discovery',
                                        position: index,
                                        uiRegion: 'certs',
                                    }),
                                )
                            }
                        >
                            <CertificationPreparationProductCard
                                layout="vertical"
                                className={styles.card}
                                mediaSquare={undefined}
                                mediaWide={
                                    <CertificationPreparationProductCard.CardMediaImage
                                        src={card.image}
                                        alt={card.alt}
                                        layout="wide"
                                    />
                                }
                                title={
                                    <CardTitle
                                        headingLevel="h3"
                                        renderLink={CardTitle.renderAnchorTag({
                                            href: card.url,
                                            className: 'ud-link-knockout',
                                            onClick: () =>
                                                tracker.publishEvent(
                                                    createDiscoveryItemClickEvent({
                                                        id: index,
                                                        type: 'course_topic',
                                                        trackingId: card.id,
                                                        serveTrackingId: '',
                                                        backendSource: 'discovery',
                                                        position: index,
                                                        uiRegion: 'certs',
                                                    }),
                                                ),
                                        })}
                                    >
                                        {card.title}
                                    </CardTitle>
                                }
                                description={
                                    <p className={`${styles['card-description']} ud-text-xs`}>
                                        {card.description}
                                    </p>
                                }
                            />
                        </TrackImpression>
                    ))}
                </div>
            </div>
        </section>
    );
};
